<template>
  <selfcheck-calling-modal
    :visible="modalShow"
    :invert="isCheckPage"
    :disabled="isCanceling"
    @cancel="cancel"
  >
    <so-quit-button-container v-if="isCheckPage" />
  </selfcheck-calling-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'

import SelfcheckCallingModal from '@/components/modal/SelfcheckCallingModal'
import SoQuitButtonContainer from '@/components/common/SoQuitButton.container'

export default {
  components: {
    SelfcheckCallingModal,
    SoQuitButtonContainer,
  },
  data() {
    return {
      isCanceling: false,
    }
  },
  computed: {
    ...mapGetters({
      modalShow: 'modal/isShowingSelfcheckCallingModal',
      error: 'selfcheck/getError',
    }),
    isCheckPage() {
      return this.$route.name === 'check'
    },
  },
  methods: {
    ...mapActions({
      fetchSeat: 'seat/fetchSeat',
      cancelSelfcheck: 'selfcheck/cancelSelfcheck',
      setShowingSimpleErrorModal: 'modal/setShowingSimpleErrorModal',
      setShowingSelfcheckErrorModal: 'modal/setShowingSelfcheckErrorModal',
    }),
    async cancel() {
      if (this.isCanceling) return
      this.isCanceling = true
      await this.cancelSelfcheck({ callStaff: false })

      if (!this.error) {
        await this.getSeat()
        this.navigateToTopIfNeeded()
      } else {
        if (this.error.response) {
          this.setShowingSelfcheckErrorModal(true)
        } else {
          this.setShowingSimpleErrorModal(true)
        }
      }
      this.isCanceling = false
    },
    async getSeat() {
      this.cancelTokenSource = axios.CancelToken.source()
      await this.fetchSeat(this.cancelTokenSource.token)
    },
    navigateToTopIfNeeded() {
      if (this.$route.name === 'shopMenu') {
        this.$router.replace({ name: 'shopMenu' })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .modal {
    top: 0px;
  }
  .modal-dialog {
    margin: 0 !important;
    height: 100%;
    max-width: 100%;
  }
  .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
    background: none;
  }
  .modal-body {
    height: 100%;
    padding: 0 !important;
  }
  .image {
    width: 84px;
    fill: #808080;
  }
  .invert .image {
    fill: #fff;
  }
}
.modal-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: #fff;
  padding-bottom: 70px;

  &.invert {
    background: rgba(0, 0, 0, 0.8);
    color: #fff;
  }
}
.text {
  padding-top: 30px;
  font-size: 20px;
}
.modal-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  justify-content: center;
  width: 100%;
  border-top: none;
}
.cancel-button {
  max-width: 240px;
}
</style>
